import * as moment from 'moment';
import { useTheme } from 'styled-components';
import { getEventType } from '../../Membership/event-list/util';
import { SwiftFoxEvent } from '../../Membership/events/contracts';
import { useDynamicListCarouselContext } from '../dynamic-lists-carousel/dynamic-list-context';
import {
	DateText,
	Description,
	DynamicCard,
	DynamicCardImage,
	DynamicCardLink,
	DynamicCardMain,
	DynamicCardWrapper,
	Title
} from '../dynamic-lists-carousel/shared';

export interface DynamicEventCardProps {
	id: number;
	event: SwiftFoxEvent;
	defaultThumbnailUrl?: string;
	hideThumbnail?: boolean;
	detailsPageUrl?: string;
	encodedEventPageId?: string;
}
export function DynamicEventCard({
	event,
	defaultThumbnailUrl,
	detailsPageUrl,
	hideThumbnail,
	encodedEventPageId,
	id
}: DynamicEventCardProps) {
	const theme = useTheme();
	const { positions, carouselState } = useDynamicListCarouselContext();
	if (!event) return <></>;
	const cardPosition = positions.find(p => p.id === id)?.position;
	const startDate = event.eventStart ? moment(event.eventStart).format('h.mm a, DD MMM YYYY') : '';
	const type = getEventType(event);
	const disable = [...carouselState.partiallyVisibleItems, ...carouselState.fullyObscuredItems].includes(id);

	return (
		<DynamicCardWrapper position={cardPosition}>
			<DynamicCardLink
				href={`${detailsPageUrl}?eventId=${event.id}&eventPageContentId=${encodedEventPageId}`}
				target="_blank"
				style={{ pointerEvents: disable ? 'none' : 'initial' }}
			>
				<DynamicCard>
					{!hideThumbnail && (event.coverImageUrl || defaultThumbnailUrl) ? (
						<DynamicCardImage src={event.coverImageUrl ?? defaultThumbnailUrl} />
					) : null}
					<DynamicCardMain>
						<DateText>
							<span style={{ color: theme.colors.primary, fontWeight: 'bold' }}>{type}</span>
							{startDate ? <span> | {startDate}</span> : null}
						</DateText>
						<Title variant="h4">{event.name}</Title>
						<Description>{event.description}</Description>
					</DynamicCardMain>
				</DynamicCard>
			</DynamicCardLink>
		</DynamicCardWrapper>
	);
}
